import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";

const reasons = [
  {
    icon: "ri-map-pin-line",
    title: "Convenient Miami location",
    description: "A local clinic address in Miami, Florida that is easy to plan a visit around.",
  },
  {
    icon: "ri-layout-grid-line",
    title: "Multiple services in one clinic",
    description:
      "Orthopedic, pain-related, diagnostic, and wellness services available through one practice.",
  },
  {
    icon: "ri-microscope-line",
    title: "Outpatient diagnostic support",
    description: "Testing such as laboratory work, X-rays, sonograms, and electrocardiograms on site.",
  },
  {
    icon: "ri-chat-smile-2-line",
    title: "Personalized communication",
    description: "Clear, direct conversation about services, availability, and what to expect.",
  },
  {
    icon: "ri-file-list-3-line",
    title: "Straightforward appointment inquiries",
    description: "Simple ways to ask questions and request information before your visit.",
  },
];

export default function WhyChoose() {
  return (
    <section className="w-full bg-background-100 border-y border-background-200 px-4 md:px-6 py-16 md:py-24">
      <div className="max-w-content mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14">
        <div className="lg:col-span-5">
          <Reveal>
            <SectionHeading
              eyebrow="Why choose us"
              title="Why Patients Choose a Local Clinic"
              description="No awards and no marketing claims — just practical reasons patients look for care close to home."
            />
          </Reveal>
          <Reveal delay={120}>
            <div className="mt-8 rounded-xl border border-background-200 bg-background-50 p-6">
              <div className="flex items-start gap-3">
                <span className="w-10 h-10 rounded-lg bg-primary-500 flex items-center justify-center shrink-0">
                  <i className="ri-phone-line text-lg text-background-50" />
                </span>
                <div>
                  <p className="text-sm font-semibold text-foreground-950">
                    Prefer to speak with the clinic?
                  </p>
                  <p className="text-xs leading-relaxed text-foreground-600 mt-1">
                    Contact us at{" "}
                    <a
                      href="tel:+15095089985"
                      className="font-semibold text-primary-700 hover:text-primary-600 cursor-pointer"
                    >
                      (509) 508-9985
                    </a>{" "}
                    to ask about services and availability.
                  </p>
                </div>
              </div>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <Reveal>
            <ul className="space-y-4">
              {reasons.map((reason) => (
                <li
                  key={reason.title}
                  className="flex items-start gap-4 rounded-xl border border-background-200 bg-background-50 p-5 transition-colors duration-200 hover:border-primary-300"
                >
                  <span className="w-11 h-11 rounded-lg bg-secondary-100 flex items-center justify-center shrink-0">
                    <i className={`${reason.icon} text-xl text-secondary-700`} />
                  </span>
                  <div>
                    <h3 className="font-heading text-base font-semibold text-foreground-950">
                      {reason.title}
                    </h3>
                    <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">
                      {reason.description}
                    </p>
                  </div>
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </div>
    </section>
  );
}